module.exports = __webpack_public_path__ + "components/country-flag/static/hr-26bd1d1bc08f25f3c4cd1c09fb4d039a.svg";